import Module from '../utils/Module';
import PopupModule from "./PopupModule";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "../vendors/SplitText.min";
import EventsManager from '../utils/EventsManager';
import CustomEvents from '../utils/CustomEvents';
import ResizeManager from '../utils/ResizeManager';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

export default class HomepageModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;

    this.popup = new PopupModule(options);

    this.map = this.DOMEl.querySelector('.map');
    this.mapButtons = this.map.querySelectorAll('.btn');
    this.popupCloseButtons = this.DOMEl.querySelectorAll('.popup-close-button');
    this.bgPopups = this.DOMEl.querySelectorAll('.bg-popup');

    this.scrollImageContainer = this.DOMEl.querySelector(".container-images");
    this.scrollImageWrapper = this.DOMEl.querySelector(".wrapper-images");
    this.wrappertext = this.DOMEl.querySelector('.wrapper-home');
    this.title = this.DOMEl.querySelectorAll(".title-home");
    this.link = this.DOMEl.querySelector(".link-home")
    this.titleItalics = this.DOMEl.querySelectorAll(".title-home em");
    this.sections = this.DOMEl.querySelectorAll(".portion");
    if(this.scrollImageWrapper)
    {
      this.imageContainer = this.scrollImageWrapper.querySelector(".container-scroll");
    }
    this.containers = this.DOMEl.querySelectorAll(".container-scroll");

    this.introTextImage = this.DOMEl.querySelector('.intro-text-image');
    if( this.introTextImage)
    {
      this.introTextImageBg = this.introTextImage.querySelector('.image-bg');
    }
    this.introEnd = this.DOMEl.querySelector('.end-intro');
    this.overlay = this.DOMEl.querySelector(".overlay");

    //const clonedImageContainer = this.imageContainer.cloneNode(true);
    //this.scrollImageWrapper.appendChild(clonedImageContainer);

    this.parallaxImages = this.DOMEl.querySelectorAll(".bloc-image-container");
    this.firstBlocImage = this.DOMEl.querySelectorAll(".bloc-image")[0];
    this.firstBlocImage.classList.add("first-bloc");
    //this.titleItalics[0].classList.add("color-italic");

    this.timeline = gsap.timeline({delay: 0.4}).pause();

    this.buttonAppear = false;
    this.animComplete = false;
    this.oldScroll = 0;

    this.init();
  }

  init () {

    this.mapButtons.forEach((button, index) => {
      let modal = this.DOMEl.querySelector('.popup-' + button.getAttribute('data-modal'));

      button.addEventListener('click', () => {
        this.popup.openPopup(modal);
      })
    });

    this.popupCloseButtons.forEach(button => {
      let modal = this.DOMEl.querySelector('.popup-' + button.getAttribute('data-modal'));
      button.addEventListener('click', () => {
        this.popup.closePopup(modal);
      });
    });

    this.bgPopups.forEach(button => {
      let modal = this.DOMEl.querySelector('.popup-' + button.getAttribute('data-modal'));
      button.addEventListener('click', () => {
        this.popup.closePopup(modal);
      });
    });

    this.parallaxImages.forEach( (parallaxImage)  => {
      //this.setupParallaxImage(parallaxImage)
    });

    this.splittedTitle = new SplitText(this.title,  {type:"words", wordsClass: "split-line"});

    this.splittedTitle.words.forEach(word =>{
      const wrapper = document.createElement('div')
      wrapper.className = 'text-reveal-transform-wrapper'
      word.parentNode.insertBefore(wrapper, word)
      wrapper.appendChild(word);
    });

    this.timeline.to(this.splittedTitle.words, {'transform':'rotate(0) translate3d(0,-5px,0)', duration: 0.5 , ease: "power2.out", stagger:0.05})
    this.timeline.to(this.firstBlocImage, {'transform':'translate3d(0,0,0)', opacity: 1, duration: 0.7 , ease: "power2.out", onComplete: () => {
      this.animComplete = true;
    }});

    gsap.timeline({
      scrollTrigger: {
        trigger: this.introTextImageBg,
        scrub: true,
        start: "top bottom-=200",
        end: "top center-=200"
      }
    }).to(this.introTextImageBg, { 'width': '100%','border-top-left-radius':'0'})
      .to(this.overlay, {'opacity':'1'}, 0);

    gsap.timeline({
      scrollTrigger: {
        trigger: this.introEnd,
        scrub: true,
        start: "top bottom-=130",
        end: "top center",
        onLeave: () => this.wrappertext.style.visibility = 'hidden',
        onEnterBack: () => this.wrappertext.style.visibility = 'visible',
      }
    }).from(this.wrappertext,  { 'opacity': '1'})
      .to(this.wrappertext, { 'opacity': '0'});

    this.scrollImageContainer.scrollTop = 1;


    ResizeManager.bind("home-size", this.onResize.bind(this));

    EventsManager.on( CustomEvents.commons.readyToStartAnims, ()=>{
      this.canAnim = true;
      this.timeline.play();
      document.addEventListener("scroll", this.onScroll.bind(this));
    });

    this.link.addEventListener('click', this.trackClick.bind(this));
  }


  onScroll(e) {

    let newScroll = document.documentElement.scrollTop;

    const steps =  (this.scrollImageContainer.scrollHeight / this.titleItalics.length);

    this.titleItalics.forEach((title, i) =>{

      if(this.oldScroll <= steps * (i + 1) && (this.oldScroll >= steps * i) ){
        title.classList.add("color-italic");
      }else{
        title.classList.remove("color-italic");
      }
    })


    if(this.oldScroll > 20 && !this.buttonAppear) {
      this.buttonAppear = true;
      gsap.to(this.link, {'transform':'translate3d(0,0,0)', opacity: 1, duration: 0.7 , ease: "power2.out"})
    }

    this.oldScroll = newScroll;
  }


  setupParallaxImage(parallaxImage) {
    const parallaxAmount = parseInt(parallaxImage.getAttribute("data-parallax"));
    const image = parallaxImage.querySelector('img');
    gsap.to(image, {
      yPercent: parallaxAmount,
      ease: "none",
      scrollTrigger: {
        scroller: this.scrollImageContainer,
        trigger: parallaxImage,
        scrub: true,
        toggleActions:'play pause play pause'
      },
    });
  }

  onResize() {
    if(this.animComplete) {
      this.splittedTitle.revert();
      this.titleItalics = this.DOMEl.querySelectorAll(".title-home em");
    }
  }

  trackClick() {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "content interaction",
        "action": this.link.querySelector('span').textContent,
        "label": window.location.href
      }
    });
  }
}
